import { Col, Divider } from 'antd';
import GenericPreferences from 'components/private/Preferences/GenericPreferences';
import React, { useMemo } from 'react';
import { PreferencesProps } from './types';
import SavePreferences from './SavePreferences';
import { useIntl } from 'react-intl';
import { AnotherOrderPicker } from './AnotherOrderPicker';
import { AnotherProductPicker } from './AnotherProductPicker';
import { JsonObject } from 'services/hitchit/types/Choices';
import { filterChoices } from './filterChoices';

const titleProps = {
  style: {
    fontSize: 'calc(1.5 * 1em)',
  },
};

const TriggerOnlineSalesCreateInvoicePreferences = ({
  onCancelChange,
  onSetPreferences,
  preferences,
  choices,
  selectedPreview,
  selectedProductPreview,
  onClearPreferences,
  onResetPreferences,
  onSaveChanges,
  onSetSelectedPreview,
  onSetSelectedProductPreview,
  isFulfilled,
  isUpdated,
  savingChanges,
  savedPreferences,
  previewOrders,
  previewProducts,
}: PreferencesProps): JSX.Element => {
  const { formatMessage } = useIntl();

  const productSupported = useMemo(() => {
    return !!preferences?.['productSupported'];
  }, [preferences]);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  return (
    <>
      <Col span={24}>
        <h2 {...titleProps}>
          {formatMessage({
            defaultMessage: 'Shopify Order to Teamleader CRM',
            description: '/onboarding/preferences/product/title',
          })}
        </h2>

        <Divider orientation="left">
          <h3>
            {formatMessage({
              defaultMessage: 'Contact',
              description: '/onboarding/preferences/contact/title',
            })}
          </h3>
        </Divider>
        {/* TODO Contact and company could be previewed based on current preferences */}
        {/* <h3>Current selection</h3>
        {selectedPreview?.crm.contact && (
          <Contact contact={selectedPreview?.crm.contact} loading={!selectedPreview} />
        )}
        {selectedPreview?.crm.company && (
          <Company company={selectedPreview?.crm.company} loading={!selectedPreview} />
        )} */}
        <GenericPreferences
          jsonObject={selectedPreview?.sale.order as unknown as JsonObject}
          choices={filterChoices(choices, 'contact')}
          preferences={preferences || {}}
          savedPreferences={savedPreferences}
          onChangeDealChoices={(key: string, updatedChoices: any) => {
            onSetPreferences({
              [key]: updatedChoices,
            });
          }}
          onClear={onClearPreferences}
          onReset={onResetPreferences}
          onCancel={onCancelChange}
          onSave={onSaveChanges}
        />
      </Col>

      <Col span={24}>
        <Divider orientation="left">
          <h3>
            {formatMessage({
              defaultMessage: 'Deal',
              description: '/onboarding/preferences/deal/title',
            })}
          </h3>
        </Divider>
        <GenericPreferences
          jsonObject={selectedPreview?.sale.order as unknown as JsonObject}
          choices={filterChoices(choices, 'deal')}
          preferences={preferences || {}}
          savedPreferences={savedPreferences}
          onChangeDealChoices={(key: string, updatedChoices: any) => {
            onSetPreferences({
              [key]: updatedChoices,
            });
          }}
          onClear={onClearPreferences}
          onReset={onResetPreferences}
          onCancel={onCancelChange}
          onSave={onSaveChanges}
        />
      </Col>
      <Col span={24}>
        <Divider orientation="left">
          <h3>
            {formatMessage({
              defaultMessage: 'Invoice',
              description: '/onboarding/preferences/invoice/title',
            })}
          </h3>
        </Divider>
        <GenericPreferences
          jsonObject={selectedPreview?.sale.order as unknown as JsonObject}
          choices={filterChoices(choices, 'invoice')}
          preferences={preferences || {}}
          savedPreferences={savedPreferences}
          onChangeDealChoices={(key: string, updatedChoices: any) => {
            onSetPreferences({
              [key]: updatedChoices,
            });
          }}
          onClear={onClearPreferences}
          onReset={onResetPreferences}
          onCancel={onCancelChange}
          onSave={onSaveChanges}
        />
      </Col>
      <Col span={24}>
        <Divider orientation="left">
          <h3>
            {formatMessage({
              defaultMessage: 'Sales order',
              description: '/onboarding/preferences/order/title',
            })}
          </h3>
        </Divider>
        <GenericPreferences
          jsonObject={selectedPreview?.sale.order as unknown as JsonObject}
          choices={filterChoices(choices, 'order')}
          preferences={preferences || {}}
          savedPreferences={savedPreferences}
          onChangeDealChoices={(key: string, updatedChoices: any) => {
            onSetPreferences({
              [key]: updatedChoices,
            });
          }}
          onClear={onClearPreferences}
          onReset={onResetPreferences}
          onCancel={onCancelChange}
          onSave={onSaveChanges}
        />
      </Col>
      <Col span={24}>
        <h2 {...titleProps}>
          {formatMessage({
            defaultMessage: 'Shopify Product Variants to Teamleader Products ',
            description: '/onboarding/preferences/product/title',
          })}
        </h2>

        <Divider orientation="left">
          <h3>
            {formatMessage({
              defaultMessage: 'Products',
              description: '/onboarding/preferences/products/title',
            })}
          </h3>
        </Divider>
        <GenericPreferences
          jsonObject={selectedProductPreview?.sale.product as unknown as JsonObject}
          choices={filterChoices(choices, 'product')}
          preferences={preferences || {}}
          savedPreferences={savedPreferences}
          onChangeDealChoices={(key: string, updatedChoices: any) => {
            onSetPreferences({
              [key]: updatedChoices,
            });
          }}
          onClear={onClearPreferences}
          onReset={onResetPreferences}
          onCancel={onCancelChange}
          onSave={onSaveChanges}
        />
      </Col>

      <Col>
        <SavePreferences
          onCancelChange={onCancelChange}
          onSaveChanges={onSaveChanges}
          isFulfilled={isFulfilled}
          isUpdated={isUpdated}
          savingChanges={savingChanges}
        />
      </Col>
      <Col span={24}>
        <Col span={24}>
          <AnotherOrderPicker
            onSetSelectedOrderPreview={onSetSelectedPreview}
            previewOrders={previewOrders}
            selectedOrderPreview={selectedPreview}
          />
        </Col>
        {productSupported && (
          <Col span={24}>
            <AnotherProductPicker
              previewProducts={previewProducts}
              onSetSelectedProductPreview={onSetSelectedProductPreview}
              selectedProductPreview={selectedProductPreview}
            />
          </Col>
        )}
      </Col>
    </>
  );
};
export default TriggerOnlineSalesCreateInvoicePreferences;
